import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ToastNotification from '../../../components/ToastNotification';
import { useLoading } from '../../../context/LoadingContext';
import moment from 'moment';


const EmployeeAttendence = ({ adminData }) => {
  const { setLoading } = useLoading();
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });


  const getCurrentDateTime = () => {
    const now = new Date();
    const istOffset = 5.5 * 60;
    const localOffset = now.getTimezoneOffset();
    const istTime = new Date(now.getTime() + (istOffset + localOffset) * 60000);

    const year = istTime.getFullYear();
    const month = String(istTime.getMonth() + 1).padStart(2, "0");
    const day = String(istTime.getDate()).padStart(2, "0");
    const hours = String(istTime.getHours()).padStart(2, "0");
    const minutes = String(istTime.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [formData, setFormData] = useState({
    emp_id: '',
    emp_name: '',
    current_date: getCurrentDateTime(),
    type: 'Present',
    check_in: '',
    check_out: '',
    checkin_loc: '',
    checkout_loc: '',


  })
  const [hasChanges, setHasChanges] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const [changedRows, setChangedRows] = useState({});

  const [error, setError] = useState("");
  const [addresses, setAddresses] = useState({});
  const [attendance, setAttendance] = useState([]);
  // Helper to show toast
  const showToast = (message, bg = 'success') => {
    setToast({ show: true, message, bg });
  };

  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({
    type: "",
    over_time: ""
  });

const today = moment().format("YYYY-MM-DD");

const [fromDate, setFromDate] = useState(today);
const [toDate, setToDate] = useState(today);





  // Date filter helpers
  const getTodayDate = () => new Date().toISOString().split('T')[0];
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    if (dateStr.includes('-')) {
      const parts = dateStr.split('-');
      if (parts[0].length === 4) return dateStr;
    }
    const [day, month, year] = dateStr.split('-');
    return `${year}-${month}-${day}`;
  };

  const handleEdit = (record) => {
  setEditId(prev => (prev === record.emp_id ? null : record.emp_id));
  setEditData({
    type: record.type,
    check_out: record.check_out?.split(".")[0] || "",
    over_time: record.over_time || ""
  });
};





  const decimalToTime = (decimalHours) => {
  const hours = Math.floor(decimalHours);
  const minutes = Math.floor((decimalHours - hours) * 60);
  const seconds = Math.floor((((decimalHours - hours) * 60) - minutes) * 60);

  return `${String(hours).padStart(2,"0")}:${String(minutes).padStart(2,"0")}:${String(seconds).padStart(2,"0")}`;
};

const handleUpdate = async (record) => {
  try {
     const overTimeAsTime = decimalToTime(parseFloat(editData.over_time || 0));
    // Prepare payload
    const payload = {
      type: editData.type,
      check_out: editData.check_out,
      over_time: overTimeAsTime,
    };

    // Send update to backend
    await axios.put(`https://api.skyguard.group/api/update-attendance/${record.emp_id}`, payload);

    // Update UI locally
    setAttendance(prev =>
      prev.map(item =>
        item.emp_id === record.emp_id
          ? { ...item, ...payload } // update type, check_out, over_time
          : item
      )
    );

    setEditId(null);
    showToast('Attendance updated successfully', 'success');
  } catch (err) {
    console.error(err);
    showToast('Failed to update employee', 'danger');
  }
};


  useEffect(() => {
    setSelectedDate(getTodayDate());
    fetchAttendance();
  }, []);




  //updatd codde 

  const displayName = `${adminData.user.first} ${adminData.user.middle ?? ""} ${adminData.user.last} - ${adminData.user.emp_id}`;





  const empId = adminData.user.emp_id;
  const todayDate = new Date().toISOString().split("T")[0];


  const todayAttendance = attendance.filter(
    record =>
      record.date === todayDate &&
      record.emp_id === adminData.user.emp_id  
  );



  const hasCheckedInToday = attendance.some(
    (record) =>
      record.emp_id === adminData.user.emp_id &&
      record.date === todayDate
  );


const displayedAttendance = attendance.filter(record => {
  const user = adminData?.user;
  if (!user) return false;

  const isAdmin = user.role?.toLowerCase() === "admin";

  const from = fromDate ? new Date(fromDate) : new Date(); 
  const to = toDate ? new Date(toDate) : new Date();

  const recordDate = record.date ? new Date(record.date) : null;


  if (!isAdmin) {
    if ((record.emp_id || "").trim().toLowerCase() !== (user.emp_id || "").trim().toLowerCase()) {
      return false;
    }
  }

  if (recordDate) {
    if (from && recordDate < from) return false;
    if (to && recordDate > to) return false;
  } else {
    return false;
  }

  // 🔹 SEARCH FILTER
  if (searchQuery) {
    const fullName = `${record.emp_first || ''} ${record.emp_middle || ''} ${record.emp_last || ''}`.toLowerCase();

    if (!fullName.includes(searchQuery.toLowerCase())) {
      return false;
    }
  }

  return true;
});

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const { latitude, longitude } = position.coords;
      setLoading(false);
    },
    (err) => {
      console.error("Geolocation error:", err);
      setLoading(false);

    }
  );


  const fetchAddress = async (lat, lng) => {
    setLoading(true)
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
      );
      const data = await response.json();
      return data.display_name || "-";
    } catch (err) {
      console.error("Error fetching address:", err);
      return "-";
    } finally {
      setLoading(false);
    }
  };


  const handleCheckIn = () => {
    if (!navigator.geolocation) {
      showToast("Geolocation is not supported by this browser", 'warning');
      return;
    }
    const now = new Date();
    const istTime = new Date(now.getTime() + 5.5 * 60 * 60 * 1000);

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const payload = {
          type: "Present",
          check_in: istTime.toISOString(),
          date: formData.current_date,
          emp_name: displayName,
          checkin_loc: JSON.stringify({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }),
        };

        try {
          const res = await axios.post(`https://api.skyguard.group/api/attendance-checkin/${adminData.user.emp_id}`,
            payload
          );

          showToast('Check-in successful', 'success');
             fetchAttendance();
        } catch (error) {
          console.error(error);
          showToast('Check-in failed', 'danger')
        }
      },
      (error) => {
        console.error(error);
        showToast('Location permission denied', 'warning')

      }
    );
  };



  const handleCheckOut = (attendanceId) => {
    if (!navigator.geolocation) {
      showToast("Geolocation is not supported by this browser", 'warning');
      return;
    }

    const now = new Date();
    const istTime = new Date(now.getTime() + 5.5 * 60 * 60 * 1000);

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const payload = {
          emp_id: adminData.user.emp_id,
          check_out: istTime.toISOString(),
          checkout_loc: JSON.stringify({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }),
        };
        try {
          const res = await axios.put(`https://api.skyguard.group/api/attendance-checkout/${attendanceId}`,
            payload
          );
          showToast('Check-out successful', 'success')
          fetchAttendance();
        } catch (error) {
          console.error(error);
          showToast('Check-out failed', 'danger')
        }
      },
      (error) => {
        console.error(error);
        showToast('Location permission denied', 'warning')
      }
    );
  };

  useEffect(() => {

    if (empId) fetchAttendance();
  }, [empId]);

  useEffect(() => {
    fetchAttendance();
  }, []);


const fetchAttendance = async () => {
  setLoading(true);

  try {
    const params = {
      from: fromDate || moment().format("YYYY-MM-DD"),
      to: toDate || moment().format("YYYY-MM-DD"),
    };

    if (adminData.user.role !== "Admin") {
      params.emp_id = adminData.user.emp_id;
    }

    const response = await axios.get(
      "https://api.skyguard.group/api/get-attendance",
      { params }
    );

    let data = response.data.data || [];

    setAttendance(data);

  } catch (err) {
    console.error(err);
    setError("Failed to fetch attendance");
  } finally {
    setLoading(false);
  }
};


  const getISTTimeString = () => {
    const now = new Date();
    const istNow = new Date(now.getTime() + 5.5 * 60 * 60 * 1000);

    const hours = String(istNow.getHours()).padStart(2, "0");
    const minutes = String(istNow.getMinutes()).padStart(2, "0");
    const seconds = String(istNow.getSeconds()).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  };

const handleLeaveAbsent = async ({ emp_id, emp_name, type }) => {

  try {
    const today = moment().format("YYYY-MM-DD");

    const payload = {
      emp_id,
      emp_name,
      date: today,
      type,           
      check_in: null,
      check_out: null,
      checkin_loc: null,
      checkout_loc: null,
    };



    const response = await axios.post(
      "https://api.skyguard.group/api/mark-leave",
      payload
    );

    if (response.data.success) {
      alert(`${emp_name} marked as ${type} for ${today}`);
      // Refresh attendance table if needed
      fetchAttendance();
    } else {
      alert("Failed to mark status");
    }
  } catch (err) {
    console.error(err);
    alert("Error marking status");
  }
};



const handleEditChange = (field, value, record) => {
  setEditData(prev => {
    const updatedData = { ...prev, [field]: value };

    if (field === "check_out" && record.check_in) {
      const checkInTime = record.check_in.split(".")[0]; 
      let checkOutTime = value;

      if (checkOutTime.length === 5) checkOutTime += ":00";

      const start = new Date(`1970-01-01T${checkInTime}`);
      const end = new Date(`1970-01-01T${checkOutTime}`);
      const DUTY_HOURS = 8; 
      let diff = (end - start) / (1000 * 60 * 60); 
      diff = diff - DUTY_HOURS;

      updatedData.over_time = diff > 0 ? diff.toFixed(2) : "0.00";
    
    }

    return updatedData;
  });
};

  return (
    <>
      <div className="main-section">
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <div className="container-fluid dashboard-wrapper p-3 bg-body-secondary">
          <h3 className="my-3 fw-bold fs-5 golos">Employee Attendance</h3>

          {/* Filters */}
          <div className="mb-3 row gx-3 gy-2 align-items-center">
            <div className="row g-3 align-items-end">
              <div className="col-md-3">
                <label className="form-label fw-medium">Search Employee:</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              <div className="col-md-3">
                <label className="form-label fw-medium">From Date:</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>

              <div className="col-md-3">
                <label className="form-label fw-medium">To Date:</label>
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>

              <div className="col-md-3 d-flex">
                <button
                  className="btn btn-primary"
                  style={{ minWidth: "100px" }}
                  onClick={() => fetchAttendance({ from: fromDate, to: toDate })}
                >
                  Search
                </button>
              </div>
            </div>





            <div className="row justify-content-center mt-3">
              <div className="col-12 col-sm-10 col-md-6 ">
                <div className="card shadow-sm  border-0">
                  <div className="card-body">
                    <form>
                      <div className="row">
                        <div className="col-12 mb-3">
                          <label className="form-label fw-medium">
                            Employee
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={displayName}
                            // value={getFullName(record)}
                            readOnly
                          />

                        </div>

                        <div className="col-12 mb-3">
                          <label className="form-label fw-medium">
                            Date and Time
                          </label>
                          <input type="datetime-local" className="form-control" name='current_date' value={formData.current_date} disabled />
                        </div>

                        {/* Buttons */}
                        <div className="col-12 d-flex justify-content-end gap-2 mt-3">
                          <button type="button" className="btn btn-success" onClick={handleCheckIn}
                            disabled={hasCheckedInToday}
                          >
                            Check In
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => handleCheckOut(todayAttendance[0]?.id)}

                            disabled={
                              todayAttendance.length === 0 ||
                              !!todayAttendance[0]?.check_out
                            }

                          >
                            Check Out
                          </button>


                        </div>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>

          </div>
          {/* ------------------ DAILY HEADING + ATTENDANCE TABLE ------------------ */} <div className="bg-primary text-white text-center py-2 rounded shadow-sm my-4">
            <h5 className="mb-0 fw-bold">
              {(() => {
                if (!selectedDate) return '';
                const [year, month, day] = selectedDate.split('-');
                const date = new Date(year, month - 1, day);
                return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', });
              })()}
            </h5>
          </div>

          {/* Table */}
          <div className="table-responsive shadow p-3 bg-body-tertiary rounded">
            <table className="table table-bordered table-hover text-center align-middle">
              <thead className="table-info">
                <tr>
                  <th>SN</th>
                    <th>Action</th>
                                    {adminData.user.role?.toLowerCase() === "admin" && (
        <>
        
          <th>Leave/Absent</th>
        </>
      )}
                  <th>Emp Name</th>

                  <th>Attendance Type</th>
                  <th>Check IN</th>
                  <th>Check OUT</th>
                  <th>Over Time (Hrs)</th>
                  <th>Date</th>
                  {/* <th>Action</th>
                  <th>Leave/Absent </th> */}
      
                </tr>
              </thead>

              <tbody>
                {displayedAttendance.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="text-center">
                      No attendance found for today
                    </td>
                  </tr>
                ) : (
                  displayedAttendance.map((record, idx) => (
                    <tr key={record.id}>
                      <td>{idx + 1}</td>

                        {adminData.user.role?.toLowerCase() === "admin" && ( 
<>
      
                      <td>
                        {editId === record.emp_id ? (
                          <>
                            <button
                              className="btn btn-success btn-sm me-2"
                              onClick={() => handleUpdate(record)}
                            >
                              Save
                            </button>
                            <button
                              className="btn btn-secondary btn-sm"
                              onClick={() => setEditId(null)}
                            >
                              Cancel
                            </button>
                          </>
                        ) : (
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleEdit(record)}
                          >
                            Edit
                          </button>
                        )}
                      </td>

                      <td>
                  <button
  className="btn btn-warning btn-sm mx-1"
    disabled={record.type === "Leave"}
  onClick={() =>
    handleLeaveAbsent({
      emp_id: record.emp_id,
  emp_name: `${record.emp_first || ''} ${record.emp_middle || ''} ${record.emp_last || ''}`.replace(/\s+/g, ' ').trim(),
      type: "Leave", 
    })
  }
>
  Leave
</button>

<button
  className="btn btn-danger btn-sm mx-1"
    disabled={record.type === "Absent"}
  onClick={() =>
    handleLeaveAbsent({
      emp_id: record.emp_id,
      emp_name: `${record.emp_first || ''} ${record.emp_middle || ''} ${record.emp_last || ''}`.replace(/\s+/g, ' ').trim(),
      type: "Absent", 
    })
  }
>
  Absent
</button>
                       </td>

</>

              )}
                      <td>{record.emp_first} {record.emp_middle} {record.emp_last}</td>

                      {/* TYPE */}
                      <td>
                        {editId === record.emp_id ? (
                          <select
                            className="form-select form-select-sm"
                            value={editData.type}
                            onChange={(e) => handleEditChange("type", e.target.value)}
                          >
                            <option value="Present">Present</option>
                            <option value="Absent">Absent</option>
                            <option value="Half Day">Half Day</option>
                          </select>
                        ) : (
                          record.type
                        )}
                      </td>

                      <td>{record.check_in?.split(".")[0] || "-"}</td>
                  
                     

<td>
  {editId === record.emp_id ? (
    <input
      type="time"
      className="form-control form-control-sm text-center"
      value={editData.check_out || ""}
      // onChange={(e) => handleEditChange(e.target.value)}
      onChange={(e) => handleEditChange("check_out", e.target.value, record)}
    />
  ) : (
    record.check_out?.split(".")[0] || "-"
  )}
</td>

 <td>
  {editId === record.emp_id ? (
    <input
      className="form-control form-control-sm text-center"
      value={editData.over_time || ""}
      readOnly 
    />
  ) : (
    record.over_time?.split(".")[0] || "-"
  )}
</td> 


                      <td>{record.date}</td>

                      {/* ACTIONS */}
           


                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>


    </>
  );
};

export default EmployeeAttendence;
